<template>
  <div class="h-full w-full bg-[#fff] p-10px">
    <el-row :gutter="10" class="h-full w-full !mr-0px !ml-0px">
      <el-col :span="8" class="h-full">
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <el-button size="mini"  type="primary" @click="goBack">返回</el-button>
            <span class="ml-10px text-[20px]">新增电缆桥架</span>
          </div>
          <el-select
            class="!w-200px"
            :disabled="!player"
            v-model="currentScene"
            @change="getSceneDetail"
          >
            <el-option
              v-for="item in sceneList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="h-[calc(100%-100px)] mt-10px mb-10px" v-loading="!isLoadFinish">
          <model-tree
            ref="modelTreeRef"
            :player="player"
            :sceneId="currentScene"
            v-if="isLoadFinish"
          ></model-tree>
        </div>
        <div class="text-center w-full">
          <el-button type="primary" @click="saveData">保存</el-button>
          <el-button @click="goBack">取消</el-button>
        </div>
      </el-col>
      <el-col :span="16" class="h-full">
        <SceneView
          v-if="isReday"
          :sceneOptions="sceneOptions"
          @sendPlayer="sendPlayer"
          @loadModelEnd="loadModelEnd"
        ></SceneView>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ModelSceneApi } from '@wiz-api/scene-management'
import { CableTrayApi } from '@wiz-api/tongre'
import SceneView from '../components/sceneView'
import ModelTree from '../components/modelTree'

const cableTrayApi = new CableTrayApi()
const modelSceneApi = new ModelSceneApi()

export default {
  components: { SceneView, ModelTree },
  data() {
    return {
      sceneOptions: [],
      isReday: false,
      isLoadFinish: false,
      sceneList: [],
      currentScene: '',
      player: null,
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  methods: {
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        skipCount: 0,
        maxResultCount: 9999,
      })
      if (!err) {
        this.sceneList = res.items
        this.currentScene = this.sceneList[0].id
        this.getSceneDetail()
      }
    },
    async getSceneDetail() {
      this.isLoadFinish = false
      const [err, res] = await modelSceneApi.get(this.currentScene)
      if (!err) {
        const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({
          id: this.currentScene,
        })
        if (!jsonErr) {
          const data = _.pick(res, [
            'isEnableGis',
            'latitude',
            'longitude',
            'name',
            'id',
            'folderId',
          ])
          this.sceneOptions = { ...data, jsonData: jsonRes }
        }
        this.isReday = true
      }
    },
    sendPlayer(val) {
      this.player = val
    },
    loadModelEnd() {
      this.isLoadFinish = true
    },
    goBack() {
      this.$router.push(`${this.basePath}/cable-tray/index`)
    },
    async saveData() {
      const data = await this.$refs.modelTreeRef.getTreeCheck()
      const [er, res] = await cableTrayApi.saveCableTray({ body: data })
      if (!er) {
        this.$message.success('保存成功！')
        // this.goBack()
      }
    },
  },
  mounted() {
    this.getSceneList()
  },
}
</script>

<style>
</style>
